<template>
  <div class="absolute flex items-center justify-center w-full md:min-h-full sm:min-h-screen xs-min-h-screen p-5 bg-gray-200">
    <div class="xl:max-w-[80%] lg:max-w-full md:max-w-[70%] w-full flex items-center justify-center ">
      <div class="flex flex-col justify-center items-center rounded-lg shadow-xl lg:w-full md:w-[85%] bg-white text-gray-600">
        <div class="lg:flex w-full">

          <!-- LHS -->
          <div class="hidden lg:w-9/12 bg-gray-50 lg:flex">
            <!-- SVG Animation -->
            <div class="xl:w-[680px] lg:w-[930px] lg:m-auto xl:-ml-[234px] lg:-ml-[240px] text-left">
              <svg id="lettravel" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 600 600">
                <defs>
                  <clipPath id="clip-path">
                    <rect id="n-mask" x="281.5" y="134.5" width="237" height="321" rx="115.4" fill="none" />
                  </clipPath>
                  <clipPath id="clip-path-4">
                    <rect x="281.5" y="134.5" width="237" height="321" rx="115.4" fill="none" stroke="#e5e5e6"
                      stroke-miterlimit="10" stroke-width="16" />
                  </clipPath>
                </defs>
                <rect id="window-back" x="262.3" y="108.5" width="275.39" height="373" rx="137.7" fill="#f2f2f2" />
                <!-- Night -->
                <g id="night">
                  <g clip-path="url(#clip-path)">
                    <rect x="281.5" y="134.5" width="237" height="321" rx="115.4" fill="none" stroke="#000"
                      stroke-miterlimit="10" stroke-width="15" />
                    <path fill="#3f485e" d="M216.68 129.03h344.21v243.82H216.68z" />
                    <g id="n-moon" fill="#fff">
                      <path
                        d="M394.56 241a24.5 24.5 0 005.18-15.15A24.78 24.78 0 00375 201.06c-.6 0-1.24 0-2 .09l-6 .47 3.67-4.74a30.06 30.06 0 0153.83 18.4 30.19 30.19 0 01-27.69 30l-6 .46z"
                        opacity=".5" />
                      <path
                        d="M394.49 187.87a27.34 27.34 0 00-21.67 10.64c.71-.06 1.44-.1 2.17-.1a27.4 27.4 0 0121.66 44.18 27.4 27.4 0 00-2.16-54.72z" />
                    </g>
                    <g id="n-city">
                      <path
                        d="M262.3 328.45l65.17-16.71 16.71-7.16s9.55 1.59 8.75 5.57 11.93 6.36 11.93 6.36 19.08-5.57 19.48-5.57 15.66-3.18 15.66-3.18l6.23 4 17.5 4.77s1.64 4.78 4 4.78 31.8-4.78 31.8-4.78l27.58-9.28 5.83 7 53.3-6.46 20.69-12.15L599.54 312l-53.3 173.14-283.94 20.71-74.05-118.54s-7.16-24.66-6.36-27-3.18-18.3 4-22.28 16.7-11.93 16.7-11.93 3.19-8.75 4.78-4l1.59 4.77h11.93c3.18 0 10.34-2.38 10.34-2.38l8.75 4 4 2.38z"
                        fill="#283641" />

                      <path
                        d="M169.05 387.77s58.88-30.92 65.83-32.12 17.62 0 17.62 0l21.8-.53s20.65-4.05 34.2-4.05 6.84 14.13 19 9.36 26.07-10.74 26.07-10.74l41.09-11.93s31.19-7.16 38.22-7.16h126.39s26-4.24 25.14 0 4.26 9.55 11.42 15.51 15.91-4.77 7.16 6 0 12.8-12.85 13.12-8.88 3.58-20.69-1.19-3.36 14.53-18.77 9.55-18.61-6.17-28.15-3.78 0 4-16.7 3.78-6-3.37-26.06 0-31.37-3.9-41.29.87-34.85-9.23-34.85-9.23-13.76-1.19-19.37 0-12.77 0-15.95 1.19-12.34 2.39-14.52 2.39S342 370 338.84 370h-11.33c-4.55 0-.1-1.19-8.69 0s-10.14 1.19-14.53 1.19a79.89 79.89 0 01-15.13-1.19c-7.56-1.19-7-2.39-14.86-3.58a92.84 92.84 0 00-12.59-1.19h-9.21c-6.7 0-7.86-4.77-17.62 0s-8.25 6.37-17.76 12.73-3.09 5.51-15.76 12.71-11.46 4.3-18.52 4.34 1.7 0-7.05 0-6.74-7.24-6.74-7.24z"
                        fill="#283641" />
                      <path
                        d="M279.71 404.91c7.74.87 28.52-5.11 42.53 0s28.84-.86 32.56-3.71 10.91-2 10-7.2 1.16-10.11-10-10.3-23.05 3.37-23.05 3.37-17.27-.69-24.95 0-27.12 1.81-32.78 5-6.07.5-11.7 5.54-14.86 8.35-6 9.34a90 90 0 0017.7 0"
                        fill="#283641" />
                      <path
                        d="M411.56 446.68c4.05.46 14.95-2.68 22.29 0s15.12-.45 17.07-1.94 5.73-1.06 5.23-3.78.61-5.3-5.23-5.4a46.28 46.28 0 00-12.08 1.77s-9.06-.36-13.08 0-14.22.95-17.19 2.6-3.18.26-6.13 2.9-7.8 4.38-3.15 4.9a47.57 47.57 0 009.28 0"
                        fill="#283641" />

                      <path id="n-l4" fill="#fff" d="M373.5 336.93l-3.47 3.71 8.84 11.94-5.37-15.65z" />
                      <path id="n-l3" fill="#fff" d="M298.23 358.6l6.41-14.78h-4.48l-1.93 14.78z" />
                      <path id="n-l2" fill="#fff" d="M372.49 404.18l11.93 52.77-3.76-52.77h-8.17z" />
                      <path id="n-l1" fill="#fff" d="M287.9 411.96l3.18 36.27 4.77-36.27h-7.95z" />
                    </g>
                    <g id="n-stars" fill="#fff">
                      <path class="n-star"
                        d="M490.75 226.67c-3.49 0-6.32 3.89-6.32 8.68 0-4.79-2.84-8.68-6.33-8.68 3.49 0 6.33-3.89 6.33-8.69 0 4.8 2.83 8.69 6.32 8.69z" />
                      <path class="n-star"
                        d="M309.64 259.63c-3.49 0-6.32 3.89-6.32 8.68 0-4.79-2.83-8.68-6.32-8.68 3.49 0 6.32-3.89 6.32-8.69 0 4.8 2.83 8.69 6.32 8.69z" />
                      <path class="n-star"
                        d="M337.15 176.53c-3.49 0-6.32 3.89-6.32 8.69 0-4.8-2.83-8.69-6.33-8.69 3.5 0 6.33-3.88 6.33-8.68 0 4.8 2.83 8.68 6.32 8.68z" />
                      <path class="n-star"
                        d="M471.08 274.15c-3.49 0-6.32 3.89-6.32 8.69 0-4.8-2.83-8.69-6.32-8.69 3.49 0 6.32-3.89 6.32-8.68 0 4.79 2.83 8.68 6.32 8.68z" />
                      <path class="n-star"
                        d="M515.2 171.26c-3.5 0-6.32 3.89-6.32 8.69 0-4.8-2.84-8.69-6.33-8.69 3.49 0 6.33-3.88 6.33-8.68 0 4.8 2.82 8.68 6.32 8.68z" />
                      <path class="n-star"
                        d="M416.74 291.53c-3.49 0-6.32 3.89-6.32 8.69 0-4.8-2.83-8.69-6.32-8.69 3.49 0 6.32-3.89 6.32-8.69 0 4.8 2.83 8.69 6.32 8.69z" />
                    </g>
                  </g>
                </g>
                <!-- ./ Night -->
                <!-- Sunset -->
                <g id="sunset">
                  <g clip-path="url(#clip-path)">
                    <path fill="#ffb052" d="M176.32 128.32H530V482H176.32z" />
                    <g id="s-sun" fill="#ffeed4">
                      <circle cx="400" cy="204" r="39" opacity=".5" />
                      <circle cx="400" cy="204" r="33" />
                    </g>
                    <path id="s-ml3"
                      d="M423.5 270q-1.37 0-2.7.09c-4.51-8.6-15.48-14.67-28.3-14.67a38.26 38.26 0 00-5.4.37c-5.55-5.8-14.5-9.57-24.6-9.57a38.23 38.23 0 00-12.05 1.9c-5.37-6.67-15-11.11-25.95-11.11-13.69 0-25.27 6.92-29.13 16.44-10 1.3-18.27 6.29-22.45 13.08a39 39 0 00-9.42-1.14 35.33 35.33 0 00-22 7.21 35.33 35.33 0 00-22-7.21c-16.84 0-30.5 10.48-30.5 23.4a18 18 0 00.5 4.22H454c-.27-12.75-13.83-23.01-30.5-23.01z"
                      fill="#ffca70" />
                    <path id="s-ml1"
                      d="M248 283.1s23.1-20.85 27.5-18.54 11 9.27 15.4 9.27 13.2-4.63 16.5-6.95 11-11.58 15.4-8.11 8.8 8.11 15.4 5.79 20.9-9.26 28.6-3.47S402 297 402 297H293.1s-38.5 0-45.1-13.9z"
                      fill="#ffb052" />
                    <path id="s-ml2"
                      d="M189 285s27.45-18 32.68-16 13.07 8 18.3 8 15.68-4 19.61-6 13.07-10 18.3-7 10.45 7 18.3 5 24.83-8 34-3S372 297 372 297H242.59s-45.75 0-53.59-12z"
                      fill="#e77a32" />
                    <g id="s-m2" fill="#ca413c">
                      <path
                        d="M390 312.2s27.64-23.69 32.91-21.06 13.16 10.53 18.43 10.53 15.79-5.26 19.74-7.89 13.16-13.17 18.43-9.22 10.53 9.22 18.43 6.58 25-10.53 34.22-3.95 42.12 21.07 42.12 21.07V328H444s-46.1 0-54-15.8z" />
                      <path d="M390 312.2s79.14 18.75 33.73 52c-16.79 12.3-87 34.2-84.89 103S656 496 656 496l-26-168z" />
                    </g>
                    <g id="s-m1" fill="#9b002e">
                      <path
                        d="M474 363.59s34.16-29.28 40.67-26 16.27 13 22.77 13 19.52-6.5 24.4-9.76 16.27-16.26 22.78-11.38 13 11.38 22.77 8.13 30.91-13 42.29-4.88 52.06 26 52.06 26v24.4h-161s-26.71 0-46.67-6.27c-9.25-2.83-17.01-7.09-20.07-13.24z" />
                      <path
                        d="M512.35 372.06s34.16-29.28 40.67-26 16.27 13 22.77 13 19.52-6.51 24.4-9.76S616.46 333 623 337.9s13 11.39 22.77 8.14 30.91-13 42.29-4.88 52.06 26 52.06 26v24.4h-161s-26.71 0-46.67-6.27c-9.26-2.86-17.02-7.08-20.1-13.23z" />
                      <path
                        d="M432.69 378.76s34.16-29.28 40.66-26 16.27 13 22.78 13 19.52-6.51 24.4-9.76 16.26-16.27 22.77-11.39 13 11.39 22.77 8.13 30.91-13 42.3-4.88 52 26 52 26v24.4h-161s-26.7 0-46.67-6.27c-9.18-2.86-16.94-7.08-20.01-13.23z" />
                      <path
                        d="M471.46 388.11s-14 8.2-23.07 31.82c-7.3 18.95-.88 53 22.28 51.71l138.42 8.75s-6.36-109-8.75-109-128.88 16.72-128.88 16.72z" />
                    </g>
                    <path id="s-c2"
                      d="M595.75 214.21a72.69 72.69 0 00-12 1c-3.13-10.6-19.94-18.7-40.21-18.7s-36.91 8-40.17 18.53c-17.21 2.6-29.84 11.23-29.84 21.47h163c-.03-12.32-18.27-22.3-40.78-22.3z"
                      fill="#ffca70" />
                    <path id="s-c1"
                      d="M270.46 202.51a47.77 47.77 0 00-7.81.64c-2-6.89-13-12.15-26.15-12.15s-24 5.2-26.1 12c-11.19 1.7-19.4 7.3-19.4 14h106c0-8-11.91-14.49-26.54-14.49z"
                      fill="#ffca70" />
                    <g id="s-y" fill="#9b002e">
                      <path d="M319.09 384.77A3 3 0 01318 387h-8.66a3.06 3.06 0 01-1.08-2.23z" />
                      <path d="M311.49 373.26v9.55h7.64l-7.64-9.55z" />
                    </g>
                    <g id="s-b2" fill="#9b002e">
                      <path class="s-bw2"
                        d="M314.21 221.05a9.4 9.4 0 019.3 8 9.09 9.09 0 00.12-1.39 9.42 9.42 0 10-18.83 0 10.57 10.57 0 00.11 1.39 9.41 9.41 0 019.3-8z" />
                      <path class="s-bw1"
                        d="M333 221.05a9.4 9.4 0 019.3 8 9.09 9.09 0 00.12-1.39 9.42 9.42 0 10-18.83 0 9.09 9.09 0 00.11 1.39 9.41 9.41 0 019.3-8z" />
                    </g>
                    <g id="s-b1" fill="#9b002e">
                      <path class="s-bw2"
                        d="M447.53 257.48a6 6 0 015.92 5.11 6.54 6.54 0 00.07-.89 6 6 0 00-12 0 5.26 5.26 0 00.08.89 6 6 0 015.93-5.11z" />
                      <path class="s-bw1"
                        d="M459.51 257.48a6 6 0 015.93 5.11 6.54 6.54 0 00.07-.89 6 6 0 00-12 0 6.54 6.54 0 00.07.89 6 6 0 015.93-5.11z" />
                    </g>
                    <g class="s-gl">
                      <rect class="s-gls" x="366.82" y="342.87" width="32.67" height="6.05" rx="3.03" fill="#ffca70" />
                      <rect class="s-gls" x="361.16" y="351.95" width="32.67" height="6.05" rx="3.03" fill="#ffca70" />
                      <rect class="s-gls" x="377.5" y="361.02" width="32.67" height="6.05" rx="3.03" fill="#ffca70" />
                      <rect class="s-gls" x="321.85" y="306.24" width="32.67" height="6.05" rx="3.03" fill="#ffca70" />
                      <rect class="s-gls" x="307" y="315.49" width="32.67" height="6.05" rx="3.03" fill="#ffca70" />
                      <rect class="s-gls" x="321.85" y="324.57" width="32.67" height="6.05" rx="3.03" fill="#ffca70" />
                      <rect class="s-gls" x="252.81" y="359.33" width="32.67" height="6.05" rx="3.03" fill="#ffca70" />
                      <rect class="s-gls" x="267.66" y="368.4" width="32.67" height="6.05" rx="3.03" fill="#ffca70" />
                    </g>
                  </g>
                </g>
                <!-- ./ Sunset -->

                <!-- Morning -->
                <g id="morning">
                  <g clip-path="url(#clip-path)">
                    <path id="m-bg" fill="#78ece3" d="M206.02 124.66h365.9V300h-365.9z" />
                    <path id="m-m5"
                      d="M183.48 294.24c7.27-27 29.11-59.44 50.92-58.08 25.42 1.6 33.88 48.1 54.09 46.14 18.46-1.79 17.76-41.2 40.57-47.73 25.89-7.41 42.65 38.79 80.35 39 34.84.18 43-39.13 78.76-41.36 33.19-2.07 67.16 29.18 80.35 58.87 28 63.07-20.83 157.38-89.9 194.11-106.47 56.59-246.95-31.1-284.8-112.19-5.28-11.31-19.99-42.85-10.34-78.76z"
                      fill="#6de2d9" />
                    <path id="m-m4"
                      d="M207.35 279.92c19.65 21.54 29.7 32.28 40.57 31 24.3-2.81 29.11-59 46.14-58.87 17.46.14 24.89 59.3 39 58.87 17-.51 22.1-86.77 39-87.51 16.45-.72 27 80.49 46.94 80.35 17.51-.12 24.63-62.66 43.75-62.84 17.43-.17 20.59 51.65 47.74 58.07s47.2-40.26 66.82-35.8c31.55 7.17 63.35 146.87.8 227.52-72.87 93.94-252 79.73-356.4 6.37-59.5-41.75-124.11-123.35-109.83-198.87 6.61-34.92 30.81-72.34 49.33-70.8 12.3 1.03 15.28 18.69 46.14 52.51z"
                      fill="#00b3b2" />
                    <path id="m-m3"
                      d="M260.12 323.23c19.65 21.54 29.7 32.28 40.57 31 24.3-2.81 29.11-59 46.14-58.87 17.46.13 24.89 59.3 39 58.87 17-.52 22.1-86.77 39-87.51 16.45-.72 27 80.48 46.94 80.35 17.51-.12 24.63-62.67 43.75-62.85 17.43-.16 20.59 51.65 47.74 58.07s47.2-40.25 66.82-35.79c31.55 7.16 63.35 146.87.8 227.52-72.87 93.94-252 79.72-356.4 6.36C215 498.64 150.37 417.05 164.65 341.53c6.61-34.93 30.81-72.35 49.33-70.8 12.3 1.02 15.28 18.68 46.14 52.5z"
                      fill="#00818a" />
                    <path id="m-m2"
                      d="M177.15 371.36c23.49 21.54 35.5 32.28 48.49 31 29.06-2.81 34.8-59 55.16-58.87 20.88.13 29.76 59.29 46.6 58.87 20.28-.52 26.42-86.77 46.6-87.51 19.66-.72 32.23 80.48 56.1 80.35 20.94-.12 29.44-62.67 52.31-62.85 20.82-.17 24.6 51.65 57.06 58.07s56.43-40.25 79.88-35.8c37.71 7.17 75.73 146.87.95 227.53-87.1 93.93-301.22 79.72-426 6.36C123.19 546.77 46 465.18 63 389.66c7.9-34.93 36.82-72.35 59-70.81 14.7 1.03 18.26 18.69 55.15 52.51z"
                      fill="#4b98a6" />
                    <path id="m-m1"
                      d="M229.92 424.13c23.49 21.53 35.5 32.28 48.5 31 29.05-2.81 34.79-59 55.15-58.87 20.88.14 29.76 59.3 46.6 58.87 20.28-.52 26.42-86.77 46.6-87.51 19.66-.72 32.23 80.49 56.1 80.35 20.94-.12 29.45-62.66 52.31-62.85 20.82-.16 24.6 51.66 57.06 58.08s56.43-40.26 79.88-35.8c37.71 7.17 75.73 146.87 1 227.52-87.1 93.94-301.22 79.72-426 6.37C176 599.53 98.72 517.94 115.8 442.42c7.9-34.93 36.82-72.34 59-70.8 14.67 1.03 18.2 18.68 55.12 52.51z"
                      fill="#34607e" />
                    <g id="m-sun" fill="#fff">
                      <circle cx="428.97" cy="211.57" r="32.71" opacity=".5" />
                      <circle cx="428.97" cy="211.57" r="28.97" />
                    </g>
                    <path id="m-c1"
                      d="M289.29 196.65c41.77-9.32 45-6.65 45.35-5.57 1 3-14.31 10.35-13.52 11.93s17-8.45 36.59-6.36c6.32.67 16.66 2.49 16.71 4.77.17 8.82-153.9 23-155.13 15.12-.65-4.12 41.1-13.44 70-19.89z"
                      fill="#fff" opacity=".5" />
                    <path id="m-c2"
                      d="M507.93 193.62c-12.79 9.38-16.64 12.85-19.93 15.11-9.61 6.69-16.31 4.5-46.94 6.37-16.77 1-41.13 3.28-41.1 4.77s24.26 2.51 45.08 2.39c15.56-.09 34.55-.28 58.87-4 25.42-3.87 47.24-10.14 46.94-11.93-.4-2.31-37.61 2.55-38.19-.8-.45-2.64 22.44-6.55 22.28-12.73-.09-3.12-6.05-6.08-11.14-6.36-5.49-.29-9.6 2.56-15.87 7.18z"
                      fill="#fff" opacity=".5" />
                  </g>
                </g>
                <!-- ./ Morning -->

                <!-- Window -->
                <g id="window">
                  <g clip-path="url(#clip-path-4)">
                    <path fill="#e6e6e6" d="M386.51 292.18l29.89 6.4v4.27l-23.52 2.61-44.8 4.86 38.43-18.14z" />
                    <path fill="#999" d="M416.4 298.58l-23.96 1.09-43.84 6.37-5.75 3.97 50.06.31 23.49-7.47v-4.27z" />
                    <path fill="#e6e6e6" d="M368.74 306.1l29.89 6.4v4.27l-24.13 2.66-44.19 4.82 38.43-18.15z" />
                    <path fill="#999" d="M398.63 312.5l-23.96 1.1-43.84 6.36-5.74 3.98 50.06.31 23.48-7.48v-4.27z" />
                    <path fill="#e6e6e6" d="M287.95 346.74l49.07-10.34 29.05 2.26v-5.34l-36.29-8.54-41.83 21.96z" />
                    <path fill="#999" d="M366.07 333.32l-28.34.25-43.85 6.37-8.31 6.89 52.75-1.77 27.75-6.4v-5.34z" />
                    <path fill="#999" d="M338.28 326.88l-26.54 12.88-11.32-1.11L332.64 325l5.64 1.88z" />
                    <path fill="#999" d="M357.64 317.37l-8.49 1.33 24.46-11.87 6.63.49-22.6 10.05z" />
                    <path fill="#999" d="M403.57 295.8l-16.23 7.76-.86-2.16 15.24-5.96 1.85.36z" />
                    <path fill="#e6e6e6"
                      d="M270 309.83l152.65-30.95 14.61-7.36 1.94.18 1.6 6.11-163.33 73.66-7.47-41.64z" />
                    <path fill="#999" d="M285.84 325.26l145.76-46.91 1.81-.11-152.26 51.09 4.69-4.07z" />
                    <path fill="#999" d="M422.65 278.88l18.15-1.07L444 265h-6.4l-14.95 13.88z" />
                    <path id="window-b" fill="#999" d="M280.5 134h238v15.45h-238z" />
                  </g>
                  <rect x="281.5" y="134.5" width="237" height="321" rx="115.4" fill="none" stroke="#e5e5e6"
                    stroke-miterlimit="10" stroke-width="16" />
                </g>
                <!-- ./ Window -->
              </svg>
            </div>
            <!-- ./ SVG Animation -->
            <div class="text md:w-8/12 md:mt-56 md:pr-12">
              <h1 class="font-bold text-[70px] leading-[72px]">Welcome to the <span class="rr-color">ResNova</span>
                Backoffice </h1>
              <h2 class="mt-8 text-[23px] font-light">Your control tower for creating seamless online booking
                experiences! This is where web designers and developers pilot ResNova widgets, connecting your ResRequest
                data with your website in real-time.</h2>
            </div>
          </div>
          <!-- ./ LHS -->

          <!-- RHS Login side -->
          
          <div class="lg:w-3/12 w-full py-4 xl:px-7 md:px-5 px-6 m-auto">

            <header class="text-center mb-10">
              <div class="flex justify-center items-center">
                <ToastPopup
                  v-if="showErrorToast"
                  status="error"
                  :text="errorTextWithSupportLink"
                  @close="showErrorToast = false"
                  class="text-left"
                />
                
                <img src="./assets/ResNova_Logo_New.png" alt="ResNova logo" class="w-52" />
              </div>
              <p class="mt-5">Already got your credentials from our support team? Great, you're cleared for take-off, just
                log in below.</p>
            </header>

            <!-- Form body container -->
            <form @submit.prevent="login">
              <!-- Form body -->
              <div class="flex mx-0 mt-8">
                <div class="w-full mb-5">
                  <div class="relative">
                    <input
                      name="username"
                      v-model="user.username"
                      type="text"
                      class="login-input peer"
                      id="Username"
                      required
                    />
                    <label
                      for="Username"
                      class="login-input-label"
                    >
                      {{ changeCase('username', ElementE.LABEL) }}
                    </label>
                  </div>
                </div>
              </div>
              <div class="flex mx-0">
                <div class="w-full mb-5">
                  <div class="relative">
                    <input
                      name="password"
                      v-model="user.password"
                      type="password"
                      class="login-input peer"
                      id="Password"
                      required
                    />
                    <label
                      for="Password"
                      class="login-input-label"
                    >
                      {{ changeCase('password', ElementE.LABEL) }}
                    </label>
                  </div>
                </div>
              </div>
              <div class="flex mx-0">
                <div class="w-full mb-5">
                  <button
                    class="block w-full py-3 rounded-lg text-sm text-white bg-rr-red hover:bg-red-900 focus:bg-red-900">
                    {{ changeCase('login', ElementE.BUTTON) }}
                  </button>
                </div>
              </div>
            </form>
            <div class="flex -mx-3">
              <div class="w-full px-3 mt-20 mb-5">
                <p>ResNova version {{ version }}</p>
                <p class="text-xs">
                  ResNova is a booking widget for 
                  <a href="https://www.resrequest.com/" target="_blank" class="rr-color">ResRequest</a>
                </p>
                <p class="text-xs">
                  Find out more about 
                  <a href="https://support.resrequest.com/resnova/what-is-resnova/" target="_blank" class="rr-color">ResNova</a>
                </p>
                <p class="text-xs">
                  Need to get onboard? <a href="mailto:support@resrequest.com" class="rr-color"> Email</a> and prepare to soar.
                </p>
              </div>
            </div>
            <!-- Form body container -->
            <div class="flex justify-center items-center mt-8">
              <a href="https://www.resrequest.com/" target="_blank" rel="noopener noreferrer">
                <img src="https://www.resrequest.com/wp-content/uploads/2019/12/ResRequest_Logo_New.png" alt="ResRequest logo" class="w-52" />
              </a>
            </div>

          </div>
          <!-- ./ RHS Login side -->
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import store from "../../store";
import axios from "axios";
import { useRouter } from "vue-router";
import { defineComponent, onMounted, ref } from "vue";
import { gsap } from "gsap";
import ToastPopup from "../../components/notifications/ToastPopup.vue";
import { changeCase } from '../../helpers';
import { ElementE } from '../../enums';

const API_URL = process.env.VUE_APP_API;

export default defineComponent({
  name: "LoginForm",
  components: {
    ToastPopup,
  },
  setup() {
    const version = ref<string>('');

    const getVersion = async () => {
      try {
        const { data } = await axios.get(`${API_URL}v3/fetchVersion`);
        version.value = data.version + '.' + data.build;
      } catch (error) {
        console.error(error);
      }
    };

    onMounted(() => { getVersion(); });

    return {
      version
    };
  },
  data() {
    return {
      loginError: false,
      isError: false,
      errorMessage: '',
      user: {
        username: "",
        password: "",
      },
      showErrorToast: false,

      changeCase: changeCase,
      ElementE: ElementE,
    };
  },
  computed: {
    errorTextWithSupportLink() {
      const supportEmail = 'support@resrequest.com';
      return `This account is not recognised. Check your login details and try again or contact our <a href="mailto:${supportEmail}" class="underline hover:opacity-80">support team</a>.`;
    },
  },
  watch: {
    isError: function (value: boolean) {
      if (value) {
        this.showErrorToast = true;

        setTimeout(() => {
          this.isError = false;
          this.showErrorToast = false;
        }, 3000)
      }
    }
  },

  mounted() {
    gsap.set("#window-b", {
      scaleY: 23,
      transformOrigin: "top",
    });

    const master = gsap.timeline({ repeat: -1 });

    master.add(this.morning()).add(this.sunset(), 7).add(this.night(), 14);
  },

  methods: {

    login: function () {
      const router = useRouter();

      store
        .dispatch("login", this.user)
        .then(() => {
          const widgObject: object = { name: "Widgets" };
          router.push(widgObject);
        })
        .catch((error) => {
          if (error.response.status === 500) {
            this.errorMessage = 'Internal Server Error'
          } else {
            this.errorMessage  = this.errorTextWithSupportLink;
          }
          this.isError = true;
        });
      setTimeout(() => {
        this.loginError = true;
      }, 2000);
    },

    night() {
      const nightTl = gsap.timeline({ ease: "linear" });
      const ndura = 7;

      gsap.to(".star", {
        scale: 0.3,
        transformOrigin: "center",
        stagger: {
          each: 0.1,
          from: "random",
          repeat: -1,
          yoyo: true,
        },
        duration: 0.6,
        ease: "power1.inOut",
      });

      gsap.set("#n-l1", {
        y: -20,
      });

      gsap.set("#n-l2", {
        y: -40,
      });

      gsap.to("#n-l1, #n-l2, #n-l3, #n-l4", {
        rotate: 40,
        transformOrigin: "center bottom",
        stagger: {
          each: 1,
          from: "random",
          repeat: -1,
          yoyo: true,
        },
        duration: 3,
        ease: "power1.inOut",
      }).seek(100);

      nightTl
        .to(
          "#night",
          {
            opacity: 1,
            duration: 0,
          },
          0
        )
        .to(
          "#window-b",
          {
            scaleY: 0,
            transformOrigin: "top",
            duration: 2,
            ease: "power2.out",
          },
          0
        )
        .to(
          "#n-stars",
          {
            x: 10,
            duration: ndura,
          },
          0
        )
        .to(
          "#n-city",
          {
            x: 60,
            duration: ndura,
          },
          0
        )
        .to(
          "#window-b",
          {
            scaleY: 23,
            transformOrigin: "top",
            duration: 2,
            ease: "power2.out",
          },
          5
        )
        .to(
          "#night",
          {
            opacity: 0,
            duration: 0
          },
          7
        );

      return nightTl;
    },

    sunset() {
      const gl = document.querySelectorAll(".gl");
      const sunsetTl = gsap.timeline({ ease: "linear" });
      const sdura = 10;

      gsap.to(gl, {
        x: 8,
        stagger: {
          each: 0.1,
          from: "random",
          repeat: -1,
          yoyo: true,
        },
        duration: 2,
        ease: "power1.inOut",
      });

      gsap.to(".s-bw2", {
        rotate: 25,
        transformOrigin: "right bottom",
        repeat: -1,
        yoyo: true,
        ease: "power1.inOut",
        duration: 1,
      });
      gsap.to(".s-bw1", {
        rotate: -25,
        transformOrigin: "left bottom",
        repeat: -1,
        yoyo: true,
        ease: "power1.inOut",
        duration: 1,
      });

      sunsetTl
        .to(
          "#sunset",
          {
            opacity: 1,
            duration: 0,
          },
          0
        )
        .to(
          "#window-b",
          {
            scaleY: 0,
            transformOrigin: "top",
            duration: 2,
            ease: "power2.out",
          },
          0
        )
        .to(
          "#s-ml2",
          {
            x: 30,
            duration: sdura,
          },
          0
        )
        .to(
          "#s-ml1",
          {
            x: 20,
            duration: sdura,
          },
          0
        )
        .to(
          "#s-ml3",
          {
            x: 5,
            duration: sdura,
          },
          0
        )
        .to(
          "#s-m2",
          {
            x: 50,
            duration: sdura,
          },
          0
        )
        .to(
          "#s-m1",
          {
            x: 40,
            duration: sdura,
          },
          0
        )
        .to(
          "#s-y",
          {
            x: 40,
            duration: sdura,
          },
          0
        )
        .to(
          "#s-b1",
          {
            x: 20,
            duration: sdura,
          },
          0
        )
        .to(
          "#s-b2",
          {
            x: 20,
            duration: sdura,
          },
          0
        )
        .to(
          "#s-c1",
          {
            x: 40,
            duration: sdura,
          },
          0
        )
        .to(
          "#s-c2",
          {
            x: 30,
            duration: sdura,
          },
          0
        )
        .to(
          "#window-b",
          {
            scaleY: 23,
            transformOrigin: "top",
            duration: 2,
            ease: "power2.out",
          },
          5
        )
        .to(
          "#sunset",
          {
            opacity: 0,
            duration: 0,
          },
          7
        );

      return sunsetTl;
    },

    morning() {
      const morningTl = gsap.timeline({ ease: "linear" });
      const mdura = 7;

      morningTl
        .to(
          "#morning",
          {
            opacity: 1,
            duration: 0,
          },
          0
        )
        .to(
          "#window-b",
          {
            scaleY: 0,
            transformOrigin: "top",
            duration: 2,
            ease: "power2.out",
          },
          0
        )
        .to(
          "#m-m1",
          {
            x: 70,
            duration: mdura,
          },
          0
        )
        .to(
          "#m-m2",
          {
            x: 50,
            duration: mdura,
          },
          0
        )
        .to(
          "#m-m3",
          {
            x: 35,
            duration: mdura,
          },
          0
        )
        .to(
          "#m-m4",
          {
            x: 20,
            duration: mdura,
          },
          0
        )
        .to(
          "#m-m5",
          {
            x: 20,
            duration: mdura,
          },
          0
        )
        .to(
          "#window-b",
          {
            scaleY: 23,
            transformOrigin: "top",
            duration: 2,
            ease: "power2.out",
          },
          5
        )
        .to(
          "#morning",
          {
            opacity: 0,
            duration: 0,
          },
          7
        );

      return morningTl;
    },

  },

});

</script>

<style scoped lang="scss">
*:focus-within {
  outline-width: 0 !important;
}

header {
  box-shadow: none;
}

.rr-color {
  color: #c9252f;
}

.bg-rr-red {
  background-color: #c9252f;
}

[type='text']:focus, [type='password']:focus {
  box-shadow: none;
}

// For smaller phones otherwise content gets cut
@media (max-width: 380px) {
  .xs-min-h-screen {
    height: 120%;
  }
}
</style>
